import { render, staticRenderFns } from "./textDialog.vue?vue&type=template&id=6221fbd0&scoped=true"
import script from "./textDialog.vue?vue&type=script&lang=js"
export * from "./textDialog.vue?vue&type=script&lang=js"
import style0 from "./textDialog.vue?vue&type=style&index=0&id=6221fbd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221fbd0",
  null
  
)

export default component.exports